import * as t from "io-ts";
import * as PartySellingPropertyState from "./PartySellingPropertyState";
import * as EnquiryPaymentMethod1 from "./EnquiryPaymentMethod1";

import * as BuyerReadyHasProvidedSolicitorDetails from "./BuyerReadyHasProvidedSolicitorDetails";
import * as BuyerReadyHasProvidedProofOfFunds from "./BuyerReadyHasProvidedProofOfFunds";
import * as ListingEnquiriesOffer6 from "./ListingEnquiriesOffer6";
import * as BuyerOffer1 from "./BuyerOffer1";
import { calculateRiskPoints, riskFromPoints } from "./ScoringPoints";

export const codec = t.union([
    t.literal("low"),
    t.literal("medium"),
    t.literal("high"),
]);

type T = t.TypeOf<typeof codec>;

const calculateBuyerReadyRiskOfFallThrough = (obj: {
    selling_property_state: PartySellingPropertyState.T;
    has_provided_solicitor_details: boolean;
    conveyancer_confirmed_timeframe: boolean;
    has_provided_proof_of_funds: boolean;
    payment_method: EnquiryPaymentMethod1.T;
    mortgage_broker_has_vouched: boolean;
    has_provided_mortgage_broker_details: boolean;
}): T =>
    riskFromPoints(calculateRiskPoints({
        has_provided_conveyancer_details: obj.has_provided_solicitor_details,
        conveyancer_confirmed_timeframe: obj.conveyancer_confirmed_timeframe,
        selling_property_state: obj.selling_property_state,
        has_provided_proof_of_funds: obj.has_provided_proof_of_funds,
        payment_method: obj.payment_method,
        mortgage_broker_has_vouched: obj.mortgage_broker_has_vouched,
        has_provided_mortgage_broker_details: obj.has_provided_mortgage_broker_details,
    }));

const hasMortgageBrokerDetails = (obj: {
    mortgage_broker_organisation_name: string;
    mortgage_broker_name: string;
    mortgage_broker_email_address: string | null;
    mortgage_broker_phone_number: string | null;
}): boolean =>
    !!(obj.mortgage_broker_organisation_name
    || obj.mortgage_broker_name
    || obj.mortgage_broker_email_address
    || obj.mortgage_broker_phone_number);

export const fromListingEnquiriesOffer6 = (m: ListingEnquiriesOffer6.T): T => calculateBuyerReadyRiskOfFallThrough({
    has_provided_solicitor_details: BuyerReadyHasProvidedSolicitorDetails.fromListingEnquiriesOffer6(m),
    selling_property_state: m.selling_property_state,
    conveyancer_confirmed_timeframe: m.conveyancer_confirmed_timeframe,
    has_provided_proof_of_funds: BuyerReadyHasProvidedProofOfFunds.hasProvidedProofOfFunds({
        funds_cash_verified_upto: m.funds_cash_verified_upto,
        funds_dip_verified_upto: m.funds_dip_verified_upto,
    }),
    payment_method: m.payment_method,
    mortgage_broker_has_vouched: m.mortgage_broker_has_vouched,
    has_provided_mortgage_broker_details: hasMortgageBrokerDetails({
        mortgage_broker_organisation_name: m.mortgage_broker_organisation_name,
        mortgage_broker_name: m.mortgage_broker_name,
        mortgage_broker_email_address: m.mortgage_broker_email_address,
        mortgage_broker_phone_number: m.mortgage_broker_phone_number,
    }),
});

export const fromBuyerOffer1 = (m: BuyerOffer1.T): T => calculateBuyerReadyRiskOfFallThrough({
    has_provided_solicitor_details: BuyerReadyHasProvidedSolicitorDetails.fromBuyerEnquiry1(m.enquiry),
    selling_property_state: m.party.selling_property_state,
    conveyancer_confirmed_timeframe: m.enquiry.conveyancer_confirmed_timeframe,
    has_provided_proof_of_funds: BuyerReadyHasProvidedProofOfFunds.hasProvidedProofOfFunds({
        funds_cash_verified_upto: m.enquiry.funds_cash_verified_upto,
        funds_dip_verified_upto: m.enquiry.funds_dip_verified_upto,
    }),
    payment_method: m.enquiry.payment_method,
    mortgage_broker_has_vouched: m.enquiry.mortgage_broker_has_vouched,
    has_provided_mortgage_broker_details: hasMortgageBrokerDetails({
        mortgage_broker_organisation_name: m.enquiry.mortgage_broker_organisation_name,
        mortgage_broker_name: m.enquiry.mortgage_broker_name,
        mortgage_broker_email_address: m.enquiry.mortgage_broker_email_address,
        mortgage_broker_phone_number: m.enquiry.mortgage_broker_phone_number,
    }),
});
